import React, { useEffect, useState } from "react";
import settingScheduleService from "../../../services/settingSchedule.service";
import { Form, Modal } from "antd";
import Swal from "sweetalert2";
import AddList from "./addList";

const courseListContext = React.createContext({});

const EditList = (props: any) => {
  // const { ... } = useContext<any>(courseContext);
  const { sche, curri } = props;
  const [courses, setCourses] = useState([]);
  const [showBtn, setShowBtn] = useState(false);
  useEffect(() => {
    (async () => {
      settingScheduleService.countCourse(sche.id).then((res) => {
        if (res.data.length > 0) {
          setCourses(
            res.data.filter((x: any) => x.course.owner.id === curri.id)
          );
          const count = res.data.filter(
            (x: any) => x.course.owner.id === curri.id
          ).length;
          if (count > 0) {
            setShowBtn(true);
          }
        }
      });
    })();
  }, []);

  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
    window.location.reload();
  };

  const onDelete = (list: any) => {
    const { id, course, schedule } = list;
    Swal.fire({
      title: "คุณต้องการลบ?",
      text: `รายวิชา (${course.name}) ออกจากรายการที่ต้องส่ง ปี ${schedule.term}/${schedule.year}!`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ใช่",
      cancelButtonText: "ยกเลิก",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await settingScheduleService.deleteById(id).then((res) => {
          setCourses(courses.filter((x: any) => x.id !== id));
          // console.log(res);
        });
      } else {
        console.log("กด no");
      }
    });
  };

  if (showBtn)
    return (
      <courseListContext.Provider value={{ courses, setCourses }}>
        {/* */}
        <button className="btn btn-sm btn-success" onClick={showModal}>
          <i className="bi bi-pencil-square"></i> แก้วิชา
        </button>

        <Modal
          visible={visible}
          title="ตั้งค่ารายวิชาที่ต้องส่งเอกสาร"
          width={1000}
          onCancel={handleCancel}
          footer={[
            <AddList schedule={sche.id} curri={curri} />,
            <button
              type="button"
              className="btn btn-danger ms-1"
              onClick={handleCancel}
            >
              Close
            </button>,
          ]}
        >
          <div className="row">
            <div className="col h4">
              ตั้งค่าการส่ง {sche.type === `tqf` ? `มคอ.` : `อชว.`}
              ประจำภาคการศึกษา {sche.term}/{sche.year - 2500}
            </div>
          </div>
          <div className="row">
            <div className="col h5">
              หลักสูตร : [{curri.shortName}] {curri.name}
            </div>
          </div>

          <table className="table table-hover table-responsive">
            <thead className="table-dark">
              <tr>
                <th>รหัสวิชา</th>
                <th>ชื่อวิชา</th>
                <th>อาจารย์ผู้รับผิดชอบ</th>
                <th>กลุ่มเรียนที่เปิดสอน</th>
                <th style={{ width: "15%" }}>Handle</th>
              </tr>
            </thead>
            <tbody>
              {courses.length <= 0 && (
                <tr>
                  <td colSpan={4} className="text-danger text-center">
                    <i className="bi bi-folder-x"></i>{" "}
                    ไม่มีการตั้งค่ารายวิชาที่ต้องส่ง
                  </td>
                </tr>
              )}
              {courses.map((c: any) => {
                return (
                  <tr key={c.id}>
                    <td>{c.course.courseCode}</td>
                    <td>{c.course.name}</td>
                    <td>{c.responsible}</td>
                    <td>{c.group}</td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-sm btn-danger text-white ms-1"
                        onClick={() => onDelete(c)}
                      >
                        <i className="bi bi-trash3"></i> ลบ
                      </button>
                      {/* <button
                        type="button"
                        className="btn btn-sm btn-primary text-white ms-1"
                        // onClick={() => onDelete(c)}
                      >
                        <i className="bi bi-trash3"></i> แก้ไข
                      </button> */}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Modal>
      </courseListContext.Provider>
    );
  return <></>;
};

export { courseListContext };
export default EditList;
